import { render, staticRenderFns } from "./decoration5.vue?vue&type=template&id=16e83522&scoped=true"
import script from "./decoration5.vue?vue&type=script&lang=js"
export * from "./decoration5.vue?vue&type=script&lang=js"
import style0 from "./decoration5.vue?vue&type=style&index=0&id=16e83522&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e83522",
  null
  
)

export default component.exports